import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Tooltip, IconButton } from "@mui/material";
import { ContentCopy as ContentCopyIcon } from "@mui/icons-material";

const CopyToClipboardContainer = CopyToClipboard as any;
const CopyToClipboardWrapper: React.FC<{ text: string; cell: string }> = ({
  text,
  cell
}) => {
  const [copy, setCopy] = useState("");

  const handleCopy = () => {
    setCopy(cell);
  };

  if (!text || text === "N/A") return null; // Do not show icon if no text

  return (
    <CopyToClipboardContainer text={text} onCopy={handleCopy}>
      <Tooltip
        title={
          copy === cell ? "Copied to clipboard!" : `Copy ${cell} to clipboard`
        }
        arrow
        placement="bottom-start"
      >
        <IconButton
          sx={{
            display: "flex",
            justifyContent: "start",
            textAlign: "start"
          }}
        >
          <ContentCopyIcon
            style={{
              marginTop: "0px",
              paddingTop: "0px",
              width: "0.9rem",
              height: "0.9rem"
            }}
          />
        </IconButton>
      </Tooltip>
    </CopyToClipboardContainer>
  );
};

export default CopyToClipboardWrapper;
